// extracted by mini-css-extract-plugin
export default {"button":"Password_button__El63f","buttons":"Password_buttons__0DYEY"};